export default __webpack_public_path__ + "853be92419a6c3766b9afe7a7c3e32fa.ttf";